import type {
  BillingLocationData,
  CodingScreenState,
  PatientTypeInfoData
} from '../../project_starburst/interface';

/**
 * Patient-type edit deliberately shares the facility edit gate: the single `permission` argument
 * comes from one `facilityEditPermission(caseRun, instance, userContext, roles)` call in
 * `coding-screen.tsx` and is fanned out to
 * both slots below. If patient-type editability ever needs its own rule, unwind it there -- compute
 * a second permission and add a second parameter here, rather than branching inside this function.
 */
export const injectFacilityPermission = (
  state: CodingScreenState,
  permission: 'allowed' | 'denied' | undefined
): CodingScreenState => {
  const billingLocation = state?.values?.['case.billingLocation'] as
    | BillingLocationData
    | undefined;
  const patientType = state?.values?.['case.patientType'] as
    | PatientTypeInfoData
    | undefined;
  if (!billingLocation && !patientType) return state;
  return {
    ...state,
    values: {
      ...state.values,
      ...(billingLocation && {
        'case.billingLocation': { ...billingLocation, permission }
      }),
      ...(patientType && {
        'case.patientType': { ...patientType, permission }
      })
    }
  };
};
